import classNames from 'classnames';

export const getToggleContainerClass = ({
  loading,
  activeState,
  className,
  disabled,
}: {
  loading: boolean;
  activeState: boolean;
  className?: string;
  disabled?: boolean;
}) =>
  classNames(
    'transition duration-500 rounded-full appearance-none cursor-pointer flex items-center shrink-0 w-9 h-5 p-0.5',
    {
      'cursor-not-allowed pointer-events-none': loading || disabled,
      'fill-dark': activeState && !disabled,
      'fill-dark-disabled': activeState && disabled,
      'fill-tertiary-active': !activeState && !disabled,
      'fill-tertiary': !activeState && disabled,
    },
    className
  );
